module.exports = __webpack_public_path__ + "media/images/topics/topics-ft-bg-a69de9719c3909fb375953c3c98de3e9.png";